import {
  STAGE_LABEL,
  contactMatches,
  formatAddress,
  primaryPhone,
  withinDateFilter,
  type DateFilter,
} from "@roof-hawk/core";
import { useState } from "react";

import { ListHead } from "../../components/ui";
import { t } from "../../i18n";
import { navigate } from "../../lib/hooks";
import type { AppData } from "../shell/Shell";

/** Customers, with a job count and their latest job. ADR 0002 / 0006. */
export function ContactsList({
  data,
  search,
}: {
  data: AppData;
  search: string;
}) {
  const [dateFilter, setDateFilter] = useState<DateFilter>("all");

  const rows = data.contacts
    .filter((contact) => withinDateFilter(contact, dateFilter))
    .filter((contact) => contactMatches(contact, search));

  return (
    <>
      <ListHead
        title={t("Customers")}
        count={rows.length}
        dateFilter={dateFilter}
        onDateFilter={setDateFilter}
      />
      <div className="list contacts">
        <div className="lrow head">
          <div>{t("Customer")}</div>
          <div className="hide">{t("Address")}</div>
          <div className="hide">{t("Phone")}</div>
          <div>{t("Jobs")}</div>
          <div className="hide">{t("Latest Job")}</div>
        </div>
        {rows.length === 0 ? (
          <div className="empty">
            <b>{t("No customers")}</b>
            {t("No customers match the current filters.")}
          </div>
        ) : (
          rows.map((contact) => {
            const jobs = data.jobs.filter((j) => j.contact_id === contact.id);
            const latest = jobs[0];
            return (
              <div
                key={contact.id}
                className="lrow"
                onClick={() => navigate(`contact=${contact.id}`)}
              >
                <div>
                  <div className="cust">{contact.full_name ?? "—"}</div>
                  <div className="sub">{contact.email ?? ""}</div>
                </div>
                <div className="hide sub">{formatAddress(contact)}</div>
                <div className="hide sub">{primaryPhone(contact) ?? ""}</div>
                <div>
                  <span className="jobcount">{jobs.length}</span>
                </div>
                {/* The stage, not the job number. Nobody reads a customer
                    list looking for one, and the number is still on the job. */}
                <div className="hide sub">
                  {latest ? t(STAGE_LABEL[latest.stage] ?? latest.stage) : "—"}
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
}
